import { FilesStateType } from './types';

import { FilesActionType, Pagination } from 'enums';
import { FilesActionReturnType } from 'state/actions';

const initState: FilesStateType = {
  files: [],
  page: Pagination.START_PAGE,
};

export const filesReducer = (
  // eslint-disable-next-line default-param-last
  state: FilesStateType = initState,
  action: FilesActionReturnType,
): FilesStateType => {
  switch (action.type) {
    case FilesActionType.SET_FILES:
      return { ...state, files: action.files };
    case FilesActionType.SET_FILES_PAGINATION:
      return { ...state, count: action.pagination.count, page: action.pagination.page };
    default:
      return state;
  }
};
